<template>
  <div class="dropdown float-end">
    <a @click="dropDow = !dropDow" class="btn btn-theme bg-gray no-border-box border-right-box" aria-expanded="false">
      <i class="fas fa-sliders-h"></i>
      Exibir
    </a>
    <div class="dropdown-menu dropdown-menu-end" :class="{ 'show': dropDow }">
      <div class="dropdown-item" v-for="(p, pIndex) in properties[0].properties" :key="pIndex">
        <div class="form-check form-switch">
          <input
            class="form-check-input"
            type="checkbox"
            :id="'select-'+p.propertie.id"
            :checked="viewProperties.indexOf(p.propertie.id) > -1 ? true : false"
            @click="setBoardProperties(p.propertie.id)"
          />
          <label
            class="form-check-label ms-1"
            @click="setBoardProperties(p.propertie.id)"
          >{{p.propertie.name}}</label>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  props: {
    properties: {
      type: [Object, Array]
    },
    viewProperties: {
      type: [Object, Array]
    }
  },
  data() {
    return {
      dropDow: false
    };
  },
  methods: {
    ...mapActions(["showMessage"]),
    toggleDropdown() {
      this.dropDow = !this.dropDow;
    },
    setBoardProperties(propertie) {
      this.$emit("setBoardPropertiesMini", propertie);
    }
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutsideMenu);
    
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutsideMenu);
  },
};
</script>
<style scoped>
.dropdown-menu.show {
  position: absolute;
  margin: 0px;
  padding: 0px;
  transform: translate3d(0px, 23px, 0px);
  top: 45px !important;
  right: 0px;
  width: 300px;
  height: 400px;
  overflow-y: auto;
}

.dropdown-item {
  padding: 0.55rem;
}
label {
  position: unset;
}
</style>